var Audio = {};

Audio.play = function() {

};

export default Audio;
